import type { DatasetActionsProps } from "./dataset-actions.type";

import { DatasetActionsDelete } from "./dataset-actions-delete";

import "./dataset-actions.style.less";

export const DatasetActions = ({
  datasetType,
  dataset,
  loading,
  disabled,
  beforeActions,
  afterActions,
}: DatasetActionsProps) => {
  return (
    <div className="dataset-actions">
      {beforeActions}
      <DatasetActionsDelete
        datasetType={datasetType}
        dataset={dataset}
        loading={loading}
        disabled={disabled}
      />
      {afterActions}
    </div>
  );
};
